export const Text = {
  variants: {
    breakword: {
      overflowWrap: "break-word",
      wordBreak: "break-word",
    },
  },
};
